<template>
    <div>
        <store-card class="" 
        v-for="item in items" 
        :key="item.id" 
        :store="item"> 
        </store-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters('store-filters', ['queryFilters', 'filteredStores', 'filters']),

        items () {
            return this.filteredStores;
        },
    },
    methods: {},
    mounted() {},
};
</script>
